<template>
  <div>
    <div v-for="field in this.fields" :key="field.name">
      <b>{{ field.displayName }}</b>
      <p v-if="field.value">{{ field.value }}</p>
      <p v-else>-</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MarginFields',
    props: {
      fields: { type: Array },
    }
  }
</script>
